import React, { useEffect, useState } from 'react'

// react meta tags
import { ReactTitle } from "react-meta-tags";

// redux
import { connect } from "react-redux";

// bootstrap
import { Spinner } from "react-bootstrap";

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// react toastify
import { toast } from "react-toastify";

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED,

    CUSTOMER_UPDATED_SUCCESSFULLY,
    ERROR_WHILE_UPDATING_CUSTOMER
} from "utlis/AppMessages/AppMessages";

// API
import { getCustomerDetails, updateCustomer } from 'utlis/Apis/Customers_API';

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon';

function ChangeDetails(props) {
    // props
    const {
        currentUser,
        commonToken,

        setGlobalLoading
    } = props

    // states
    const [btnLoading, setBtnLoading] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false)

    // initial form values
    const initialFormValues = {
        firstName: '',
        lastName: '',
        email: '',
        companyName: '',
        mobile: '',
    }

    // handle form validations
    const formValidationSchema = Yup.object({
        firstName: Yup.string().required('This field is required'),
        lastName: Yup.string().required('This field is required'),
        email: Yup.string().email().required('This field is required'),
        companyName: Yup.string(),
        mobile: Yup.string().required('This field is required'),
    })

    // handle form submmision
    const onFormSubmit = values => {
        if (values) {
            // button loading
            setBtnLoading(true)
            setBtnDisabled(true)

            const customerInfo = {
                user_id: currentUser.userId,
                first_name: values.firstName,
                middle_name: "",
                last_name: values.lastName,
                email: values.email,
                mobile: values.mobile,
                company_name: values.companyName,
            }

            // network request
            updateCustomer(commonToken, customerInfo).then(res => {
                // button loading
                setBtnLoading(false)
                setBtnDisabled(false)

                const resData = res.data

                // if request is success
                if (resData?.success) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success(CUSTOMER_UPDATED_SUCCESSFULLY, {
                        autoClose: 2000
                    });
                }

                // if request is error
                if (resData?.error) {

                    const errorMessage = (resData?.message?.email && resData.message.email[0]) ?? ERROR_WHILE_UPDATING_CUSTOMER

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(errorMessage, {
                        autoClose: 2000
                    });
                }

            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} updateCustomer `, err.message);

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // button loading
                        setBtnLoading(false)
                        setBtnDisabled(false)
                    },
                });
            })
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
        enableReinitialize: true
    })

    // getting user's default details
    useEffect(() => {
        // global loading
        setGlobalLoading(true)

        // getting customer details
        getCustomerDetails(commonToken, currentUser.userId).then(res => {
            // global loading
            setGlobalLoading(false)

            const resData = res.data;

            // if request succesfull
            if (resData && resData.success) {
                // setting default user details
                formik.setFieldValue("firstName", resData.data.first_name)
                formik.setFieldValue("lastName", resData.data.last_name)
                formik.setFieldValue("email", resData.data.email)
                formik.setFieldValue("companyName", resData.data.company_name)
                formik.setFieldValue("mobile", resData.data.mobile)
            }

            // if request is not succesfull
            if (resData && resData.error) {
                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(resData?.message || "Unknown error occured", {
                    autoClose: 2500,
                    onClose: () => { },
                });
            }



        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCustomerDetails `, err.message);

            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    // disabling global loading
                    setGlobalLoading(false)
                },
            });
        })
    }, [commonToken, currentUser.userId])

    return (
        <React.Fragment>

            {/* website title */}
            <ReactTitle title={"Change Your Details | krave Decor"} />

            <div className="header-sec">
                <p className="head text-capitalize st-fw-800 mb-2">Update Personal Details</p>
                <p className="desc">
                    Update your personal details.
                </p>
            </div>

            <form
                onSubmit={formik.handleSubmit}
                noValidate
                autoComplete="off">
                {/* input field */}
                <div className={`form-item mb-3 ${(formik.touched.email && formik.errors.email) ? "has-error" : ""}`}>
                    <label className="mb-2 st-fw-800">Email <span className="st-fw-400 st-fs-13 position-relative ms-2 text-black-50" style={{ top: -0.5 }}>required</span></label>
                    <input
                        type="email"
                        className="default-form-input form-control rounded-0"
                        {...formik.getFieldProps('email')}
                    />
                    {
                        (formik.touched.email && formik.errors.email) ? (
                            <div className="error-msg st-fs-12 text-danger position-relative" style={{ top: 3 }}>
                                {formik.errors.email}
                            </div>
                        ) : null
                    }
                </div>

                {/* input field */}
                <div className={`form-item mb-3 ${(formik.touched.firstName && formik.errors.firstName) ? "has-error" : ""}`}>
                    <label className="mb-2 st-fw-800">First Name <span className="st-fw-400 st-fs-13 position-relative ms-2 text-black-50" style={{ top: -0.5 }}>required</span></label>
                    <input
                        type="text"
                        className="default-form-input form-control rounded-0"
                        {...formik.getFieldProps('firstName')}
                    />
                    {
                        (formik.touched.firstName && formik.errors.firstName) ? (
                            <div className="error-msg st-fs-12 text-danger position-relative" style={{ top: 3 }}>
                                {formik.errors.firstName}
                            </div>
                        ) : null
                    }
                </div>

                {/* input field */}
                <div className={`form-item mb-3 ${(formik.touched.lastName && formik.errors.lastName) ? "has-error" : ""}`}>
                    <label className="mb-2 st-fw-800">Last Name <span className="st-fw-400 st-fs-13 position-relative ms-2 text-black-50" style={{ top: -0.5 }}>required</span></label>
                    <input
                        type="text"
                        className="default-form-input form-control rounded-0"
                        {...formik.getFieldProps('lastName')}
                    />
                    {
                        (formik.touched.lastName && formik.errors.lastName) ? (
                            <div className="error-msg st-fs-12 text-danger position-relative" style={{ top: 3 }}>
                                {formik.errors.lastName}
                            </div>
                        ) : null
                    }
                </div>

                {/* input field */}
                <div className={`form-item mb-3 ${(formik.touched.companyName && formik.errors.companyName) ? "has-error" : ""}`}>
                    <label className="mb-2 st-fw-800">Company Name</label>
                    <input
                        type="text"
                        className="default-form-input form-control rounded-0"
                        {...formik.getFieldProps('companyName')}
                    />
                    {
                        (formik.touched.companyName && formik.errors.companyName) ? (
                            <div className="error-msg st-fs-12 text-danger position-relative" style={{ top: 3 }}>
                                {formik.errors.companyName}
                            </div>
                        ) : null
                    }
                </div>

                {/* input field */}
                <div className={`form-item mb-3 ${(formik.touched.mobile && formik.errors.mobile) ? "has-error" : ""}`}>
                    <label className="mb-2 st-fw-800">Phone <span className="st-fw-400 st-fs-13 position-relative ms-2 text-black-50" style={{ top: -0.5 }}>required</span></label>
                    <input
                        type="number"
                        className="default-form-input form-control rounded-0"
                        {...formik.getFieldProps('mobile')}
                    />
                    {
                        (formik.touched.mobile && formik.errors.mobile) ? (
                            <div className="error-msg st-fs-12 text-danger position-relative" style={{ top: 3 }}>
                                {formik.errors.mobile}
                            </div>
                        ) : null
                    }
                </div>

                <div className="btns pt-1">
                    <button
                        type="submit"
                        className="btn rounded-0 btn-block text-uppercase st-fw-800 default-btn"
                        disabled={btnDisabled}>
                        {
                            btnLoading ? (
                                <Spinner animation="border" size="sm" />
                            ) : (
                                <span>Apply changes</span>
                            )
                        }
                    </button>
                </div>
            </form>
        </React.Fragment>
    )
}


const getDataFromStore = (state) => {
    return {
        currentUser: state.auth.currentUser,
        commonToken: state.auth.commonToken,
    };
};

const dispatchActionsToProps = (dispatch) => {
    return {
        setGlobalLoading: (bool) => dispatch(setGlobalLoading(bool))
    };
};

export default connect(getDataFromStore, dispatchActionsToProps)(ChangeDetails);